import { useEffect, useState } from "react";
import { FormInput } from "../../../shared/components/form-component/form-input";
import { CUSTOM_VALIDATION } from "../../../shared/validation/validation";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { SERVICES } from "../../../core/services/services";
import { CustomMessage } from "../../../shared/components/alert/custom-message";
import { CustomToast } from "../../../shared/components/alert/custom-toast";
import { HELPER } from "../../../shared/helper/helper";
import { FormDropdown } from "../../../shared/components/form-component/form-dropdown";
import { FormTextArea } from "../../../shared/components/form-component/form-text-area";
import { BACKOFFICE_CONFIGS } from "../../../shared/constants";
import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
import { Optional } from "../../../shared/components/optional/optional";

export function NewDispute(props) {
  const [loading, setLoading] = useState(false);
  const [validForm, setValidForm] = useState(false);
  const [messageTitle, setMessageTitle] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [message, setMessage] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [disputeExpiry, setDisputeExpiry] = useState(null);
  const [dispute, setDispute] = useState({
    transactionReference: "",
    reason: null,
  });
  const [otherReason, setOtherReason] = useState("");
  const [disputeError, setDisputeError] = useState({
    transactionReference: null,
    reason: null,
    otherReason: null,
  });
  const [disputeReasons, setDisputeReasons] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [logCode, setLogCode] = useState(null);

  useEffect(() => {
    const checkValidForm = () => {
      const optionalFields = ["reason"];
      const isValidForm = CUSTOM_VALIDATION.IS_VALID_FORM(
        dispute,
        optionalFields
      );
      const validErrorForm = !CUSTOM_VALIDATION.VALID_OBJ_ANY(disputeError);
      const isCorrectReference =
        dispute.transactionReference === props.transactionReference;
      if (dispute["reason"] === "Other") {
        setValidForm(
          isValidForm &&
            validErrorForm &&
            otherReason?.length &&
            isCorrectReference
        );
      } else {
        setValidForm(isValidForm && validErrorForm && isCorrectReference);
      }
    };
    checkValidForm();
  }, [dispute, disputeError, otherReason, props.transactionReference]);

  useEffect(() => {
    function getDisputeReasons() {
      SERVICES.GET_SINGLE_CONFIGURATION(BACKOFFICE_CONFIGS.DISPUTE_REASON_LIST)
        .then((response) => {
          const reasons = response?.result?.configValue?.split(",");
          let arr = [];
          // Trim cause config takes user entered input and can possibly have whitespaces
          if (reasons) {
            reasons.forEach((reason) => {
              arr.push(reason);
            });
          }
          arr.push("Other");
          setDisputeReasons(arr);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
    getDisputeReasons();
  }, []);

  function validateForm(e, name, type, refineName, required) {
    let value = e?.target?.value;
    const isEmpty = CUSTOM_VALIDATION.IS_EMPTY(value);
    const isValidInput = !isEmpty
      ? CUSTOM_VALIDATION.BASIC_VALIDATION(value, type)
      : false;

    if (isValidInput) {
      if (name === "otherReason") {
        setOtherReason(value);
        setDisputeError({ ...disputeError, [name]: null });
      } else {
        setDispute({ ...dispute, [name]: value });
        setDisputeError({ ...disputeError, [name]: null });
      }
    } else {
      let errorMessage =
        required && isEmpty ? `${refineName} is required` : null;
      if (!isValidInput) {
        errorMessage = `${refineName} is invalid`;
      }
      setDisputeError({ ...disputeError, [name]: errorMessage });
    }
  }

  function submit() {
    setLoading(true);
    let payload = { ...dispute };
    if (otherReason) {
      payload = {
        ...payload,
        reason: otherReason,
      };
    }
    SERVICES.CREATE_DISPUTE(payload, props.userType)
      .then((data) => {
        const result = data?.result;
        setMessageTitle(null);
        setSuccessMessage("Dispute logged successfully");
        setLogCode(result?.logCode);
        setDisputeExpiry(result?.tatExpiryDate);
      })
      .catch((error) => {
        setMessageTitle("Error");
        setMessage(HELPER.PROCESS_ERROR(error));
        setLoading(false);
      });
  }

  useEffect(() => {
    let counter;
    function inititializeCountdown() {
      counter = setInterval(function () {
        let countdown = HELPER.SET_COUNTDOWN(disputeExpiry);
        if (countdown) {
          setCountdown(countdown);
          setCurrentIndex(1);
          setLoading(false);
        } else {
          clearInterval(counter);
        }
      }, 1000);
    }
    if (disputeExpiry) {
      inititializeCountdown();
    }
    return () => {
      clearInterval(counter);
    };
  }, [disputeExpiry]);

  function validateDropdown(e, name) {
    const value = e.target.value;
    setOtherReason(null);
    if (value) {
      setDisputeError({ ...disputeError, [name]: "" });
      setDispute({ ...dispute, [name]: value });
    } else {
      let errorMessage = "Select reason";
      setDisputeError({ ...disputeError, [name]: errorMessage });
    }
  }

  const cancelButton = () => {
    if (!loading) {
      return (
        <button
          onClick={() => props.closeDisputeModal()}
          className="secondary-button"
        >
          Cancel
        </button>
      );
    } else {
      return <div />;
    }
  };

  const submitButton = () => {
    if (!loading) {
      return (
        <button
          disabled={!validForm}
          onClick={submit}
          className="primary-button"
        >
          Submit
        </button>
      );
    } else {
      return (
        <div className="p-mt-2 p-text-center">
          <CustomLoader loadingText="Submitting..." />
        </div>
      );
    }
  };

  const disputeForm = () => {
    return (
      <div>
        <div className="">
          <p className="custom-modal-title p-text-left p-mt-0">
            Create Dispute
          </p>
        </div>
        <div className="custom-dialog-subtitle-container-lg">
          <p className="custom-dialog-subtitle p-mb-4">
            Fill the form below to log a dispute
          </p>
        </div>
        <div className="p-grid p-text-left">
          <p className="text-small p-ml-2">
            Enter the transaction reference,<b> {props.transactionReference}</b>
            , below to log a dispute
          </p>
          <div className="p-col-12">
            <FormInput
              value={dispute["transactionReference"]}
              required={true}
              field="transactionReference"
              type="NAME"
              error={disputeError["transactionReference"]}
              fn={validateForm}
              loading={false}
              placeholder="Transaction Reference"
            />
          </div>
          <div className="p-col-12 p-mt-3">
            <FormDropdown
              required={true}
              error={null}
              disabled={loading}
              field="reason"
              value={dispute["reason"]}
              fn={validateDropdown}
              options={disputeReasons}
              placeholder="Dispute Reason"
              onShow={() => setIsDropdownOpen(true)}
              onHide={() => setIsDropdownOpen(false)}
            />
          </div>
          {dispute["reason"] === "Other" && (
            <div className="p-col-12 dispute-reason">
              {/* Other: {otherReason} */}
              <FormTextArea
                required={false}
                field="otherReason"
                type="DESCRIPTION"
                error={disputeError["otherReason"]}
                fn={validateForm}
                loading={loading}
                placeholder="Dispute reason"
              />
            </div>
          )}
          <Optional show={messageTitle}>
            <div className="p-col-12 p-mt-0">
              <CustomToast
                title={messageTitle}
                description={message}
                type="error"
              />
            </div>
          </Optional>
          <div
            className="p-col-12 p-mt-5"
            style={{ marginBottom: isDropdownOpen ? "6rem" : "0" }}
          >
            <div className="p-grid">
              <div className="p-col-6">{cancelButton()}</div>
              <div className={loading ? "p-col-12" : "p-col-6"}>
                {submitButton()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const currentView = () => {
    if (currentIndex) {
      return (
        <div className="p-text-center p-mt-2">
          <div>
            <CustomMessage messageType="success" />
          </div>
          <div>
            <p className="success-message-text">{successMessage}</p>
            <p className="countdown-text success-message-text">Expires in:</p>
            <p className="countdown-text success-message-text">{countdown}</p>
            <p className="countdown-text success-message-text">Log code:</p>
            <p className="countdown-text success-message-text">{logCode}</p>
          </div>
          <div className="success-message-btn-container p-text-center">
            <p
              className="close-modal add-cursor p-mt-3"
              onClick={() => props.closeDisputeModal(true)}
            >
              Close
            </p>
          </div>
        </div>
      );
    } else {
      return <div>{disputeForm()}</div>;
    }
  };

  return (
    <ErrorBoundary>
      <div className="p-pb-5">{currentView()}</div>
    </ErrorBoundary>
  );
}
